import { put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { api, makeRequest } from 'shared/sdk';
import { COMPANY_DETAIL_URL } from 'global-constants';
import { substituteUrl } from 'shared/utils/substituteUrl';

const actionPrefix = 'ConfirmClaimRequest/';

const REQUEST_CONFIRM_CLAIM_REQUEST = `${actionPrefix}REQUEST_CONFIRM_CLAIM_REQUEST`;
const SUCCESS_CONFIRM_CLAIM_REQUEST = `${actionPrefix}SUCCESS_CONFIRM_CLAIM_REQUEST`;
const FAIL_CONFIRM_CLAIM_REQUEST = `${actionPrefix}FAIL_CONFIRM_CLAIM_REQUEST`;

export const requestConfirmClaimRequest = claimRequestId => ({
  type: REQUEST_CONFIRM_CLAIM_REQUEST,
  payload: { claimRequestId }
});

const successConfirmClaimRequest = data => ({
  type: SUCCESS_CONFIRM_CLAIM_REQUEST,
  payload: data
});

const failConfirmClaimRequest = errors => ({
  type: FAIL_CONFIRM_CLAIM_REQUEST,
  payload: errors
});

const initialState = {
  loading: true,
  failed: false,
  errors: null
};

export const confirmClaimRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case FAIL_CONFIRM_CLAIM_REQUEST:
      return {
        ...state,
        loading: false,
        failed: true,
        errors: action.payload
      };
    default:
      return state;
  }
};

function* requestConfirmClaimRequestWorker(action) {
  const response = yield makeRequest(api.confirmClaimRequest, {
    lookupData: { claimRequestIdentifier: action.payload.claimRequestId }
  });

  if (response.success) {
    yield* [
      put(successConfirmClaimRequest(response.data)),
      put(
        push(
          substituteUrl(COMPANY_DETAIL_URL, {
            companySlug: response.data.vendor_slug
          })
        )
      )
    ];
  } else yield put(failConfirmClaimRequest(response.errors));
}

export function* confirmClaimRequestSaga() {
  yield takeLatest(
    REQUEST_CONFIRM_CLAIM_REQUEST,
    requestConfirmClaimRequestWorker
  );
}
